import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CipHeader from "./CipHeader";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import moment from "moment";

import DatePicker from "react-datepicker";
import regionService from "../services/regions-service";
import kopService from "../services/kop-service";
import formsService from "../services/forms-service";
import { setFormresultList } from "../state/reducers/formsResultSlice";
import Loader from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";

const ExpirationReport = ({ setFormresultList, history }) => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [regionsList, setRegionsList] = useState([]);
  const [kopsList, setKopsList] = useState([]);
  const [loading, setLoading] = useState(false);
  // react hook form
  const { register, handleSubmit, errors, setValue } = useForm({});
  const generateReport = async (data) => {
    try {
      if (!startDate || !endDate || startDate > endDate) {
        const { hide } = cogoToast.error(
          "Please chose valid start date and end date ",
          {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          }
        );
      } else {
        let new_arry = {
          begin: moment(startDate).format("YYYY-MM-DD"),
          close: moment(endDate).format("YYYY-MM-DD"),
          regions: data.region,
          kop: data.kop,
          pageBreak: true,
        };
        setFormresultList({ expFormDetails: new_arry });
        setLoading(true);
        let resp = await formsService.getExprationPdf(new_arry);
        setLoading(false);
        if (resp.code && resp.code !== 200) {
          const { hide } = cogoToast.error(
            "Error retrieving expiration pdf. Please try after sometime.",
            {
              hideAfter: 15,
              onClick: () => {
                hide();
              },
            }
          );
        } else {
          await history.push("/expirationPage");
        }
      }
    } catch (e) {
      const { hide } = cogoToast.error("Record Not Found!", {
        hideAfter: 15,
        onClick: () => {
          hide();
        },
      });
    }
  };
  const getDetails = async () => {
    try {
      setLoading(true);
      let resp = await regionService.getRegions();
      if (resp) {
        setRegionsList(resp);
      }
      let kopList = await kopService.getKopList();
      if (kopList) {
        setKopsList(kopList);
      }
      setValue("kop", "P");
      setLoading(false);
    } catch (e) {}
  };
  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">SCRIPT EXPIRATION REPORT</span>
          </div>
        </div>  
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(generateReport)}>
            <ul className="">
              <li className="inline-block text-xs text-menu_txt leading-10 w-full">
                1. Select a Starting and Ending Date Range.
              </li>
              <li className="inline-block text-xs leading-10 text-menu_txt w-full">
                2. Click Generate Report when ready to create report.
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/2 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">Start Date</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                    setEndDate(
                      moment(date, "MM-DD-YYYY").add(10, "days").toDate()
                    );
                  }}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-1/2 mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">End Date</label>
                <DatePicker
                  placeholderText="MM/DD/YYYY"
                  name="endDate"
                  selected={endDate}
                  disabled={true}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">Region</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="region"
                  aria-label="Select Region"
                  ref={register({
                    required: "You must select region",
                  })}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                >
                  <option value="">Select Region</option>
                  {regionsList
                    ? regionsList.map((region, i) => {
                        return (
                          <option key={i} value={region.id}>
                            {region.name}
                          </option>
                        );
                      })
                    : null}
                </select>
                {errors.region && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.region?.message}
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">KOP Status</label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>
                <select
                  name="kop"
                  id="kop"
                  aria-label="Select KOP"
                  ref={register({
                    required: "You must specify KOP Status",
                  })}
                  className="border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                >
                  <option value="">Select KOP STATUS</option>
                  {kopsList
                    ? kopsList.map((kop, i) => {
                        return (
                          <option key={i} value={kop.id}>
                            {kop.name}
                          </option>
                        );
                      })
                    : null}
                </select>
                {errors.kop && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.kop?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-sm leading-10 w-full">
                <button
                  type="submit"
                  label="Submit"
                  className="text-white rounded font-semibold text-sm h-10 w-full bg-secondary bg-login_btn mb-3"
                >
                  GENERATE REPORT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({ setFormresultList }, dispatch);
    }
  )(ExpirationReport)
);
